import { COMPONENT_VALUE_TYPES as types, TWO_COLUMN_TEXT_LAYOUTS } from 'shared/constants';

const propsSchema = [
  {
    key: 'sections',
    label: 'Sections',
    type: types.ARRAY,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT
      },
      {
        key: 'tag',
        label: 'Tag',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'location',
    label: 'Location (left/right)',
    type: types.ENUM,
    options: TWO_COLUMN_TEXT_LAYOUTS
  },
];

const defaultProps = {
  sections: [
    { label: 'Design', tag: 'design' },
    { label: 'Performance', tag: 'performance' },
    { label: 'Technology', tag: 'technology' },
    { label: 'Interior', tag: 'interior' }
  ],
  location: 'LEFT',
};

export default {
  title: 'Vertical Nav Bar',
  id: 'VerticalNavBar',
  widgetImage: `/widgetImages/Vertical+navigation.png`,
  basic: true,
  propsSchema,
  defaultProps
};
